<template>
	<!-- Handles all the screensaver logic -->
	<Screensaver />
	<!-- The header with the logo of the museum -->
	<header>
		<Logo />
	</header>
	<!-- Our main container that holds all of our views -->

	<div id="museum-container" class="container-fluid p-0 museum-container" :style="containerBackground">
		<router-view></router-view>
	</div>

	<!-- The footer -->
	<footer class="museum-footer">
		<div class="h-100 d-flex">
			<!-- This button make us go back to the main page -->
			<router-link class="h-100 d-flex museum-home-btn" to="/">
				<div class="my-auto">
					<span class="align-middle text-white back-to-home-btn">
						<i class="museum-home-icon fs-1 align-middle me-3"></i>{{ t('back_to_start')}}
					</span>
				</div>
			</router-link>
			<!-- All the languages we can switch between -->
			<div v-if="$store.state.settings.languages.length > 1" class="ms-auto d-flex">
				<div class="h-100 d-flex">
					<span @click="changeLocale(`${language}`)" class="h-100 d-flex museum-locale-btn" v-for="language in $store.state.settings.languages" :key="language">
						
						<i v-if="language == 'nl'" class="flag-icon flag-icon-nl my-auto"></i>
						<p v-if="language == 'nl'" class="museum-locale-text my-auto">Nederlands</p>

						<i v-if="language == 'en'" class="flag-icon flag-icon-gb my-auto"></i>
						<p v-if="language == 'en'" class="museum-locale-text my-auto">English</p>

						<i v-if="language == 'de'" class="flag-icon flag-icon-de my-auto"></i>
						<p v-if="language == 'de'" class="museum-locale-text my-auto">Deutsch</p>
					</span>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
import { useI18n } from "vue-i18n";
import Screensaver from "./components/screensaver/Screensaver.vue";
import Logo from "./components/overlay/Logo.vue";
import store from "./store";

export default {
	components: { Screensaver, Logo },
	setup() {
		const { t, te } = useI18n();
		return { t, te };
	},
	computed: {
		containerBackground() {
			if(store.state.settings.colors.other.use_image)
			{
				return `background-image: url('${store.state.settings.colors.other.background_image}');`;
			} else {
				return `background-color: ${store.state.settings.colors.other.background_color};`;
			}
		}
	},
	mounted() {
	},
	methods: {
	},
};
</script>
<style scoped>
.back-to-home-btn {
	font-size: 20px;
	font-weight: 400;
}
</style>